import {useMutation, UseMutationResult} from '@tanstack/react-query';

import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../../../service/api/api-const';
import {serialize} from '../../../../util/api-adapter';
import {FetchMethodEnum, fetchX} from '../../../../util/fetch';

export function useShowAutotagsMutation(): UseMutationResult<void, unknown, boolean> {
    return useMutation({
        mutationFn: (isShow) => {
            const body = {isShowAutotags: isShow};

            return fetchX<void>(`${rootApiUrl}/v2/user/own/`, {
                method: FetchMethodEnum.put,
                body: JSON.stringify(serialize(body)),
                headers: {...mainApiHeaders, ...getCsrfHeaders()},
            });
        },
    });
}
